module.exports = __webpack_public_path__ + "static/media/HelveticaNeueCyr-Medium.e603c690.ttf";